"use client";

import dynamic from "next/dynamic";

import { Container } from "@/components/layout/container";

const PromoSlider = dynamic(() =>
  import("./promo-slider").then((mod) => mod.PromoSlider),
);

const PopularDestination = dynamic(() =>
  import("./popular-destination").then((mod) => mod.PopularDestination),
);

const TopDestination = dynamic(() =>
  import("./top-destination").then((mod) => mod.TopDestination),
);

export function DeferredHomeSections() {
  return (
    <>
      <Container className="my-6">
        <PromoSlider />
      </Container>
      <Container className="my-6 py-4">
        <PopularDestination />
      </Container>
      <TopDestination />
    </>
  );
}
